import React from "react";
import axios from "axios";
import isEmail from "validator/lib/isEmail";
import Field from "./Field";
import TextArea from "./TextArea";
import { Icon } from "react-fa";

// TODO: Implement the contact form back-end!

export default class Form extends React.Component {
  static displayName = "Contact Form";

  state = {
    fields: {
      name: "",
      email: "",
      message: ""
    },
    fieldErrors: {},
    _submitStatus: "READY"
  };

  onInputChange = ({ name, value, error }) => {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;

    fields[name] = value;
    fieldErrors[name] = error;

    this.setState({ fields, fieldErrors, _submitStatus: "READY" });
  };

  validate = () => {
    const message = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter(k => fieldErrors[k]);

    if (!message.name) return true;
    if (!message.email) return true;
    if (errMessages.length) return true;

    return false;
  };

  clearFields = evt => {
    evt.preventDefault();
    if (this.state._submitStatus === "SUBMITTING") return;
    this.setState({
      fields: {
        name: "",
        email: "",
        message: ""
      },
      fieldErrors: "",
      _submitStatus: "READY"
    });
  };

  onFormSubmit = evt => {
    const { name, email, message } = this.state.fields;
    const API_ENDPOINT =
      "https://bboybdo99c.execute-api.us-east-1.amazonaws.com/beta/contact";

    evt.preventDefault();

    if (this.validate()) return;

    this.setState({ _submitStatus: "SUBMITTING" });

    axios
      .post(
        API_ENDPOINT,
        JSON.stringify({ name: name, email: email, message: message })
      )
      .then(result => {
        if (result.status === 200) {
          this.setState({
            fields: {
              name: "",
              email: "",
              message: ""
            },
            _submitStatus: "SUCCESS"
          });
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({ _submitStatus: "ERROR" });
      });
  };
  render() {
    return (
      <div>
        <form onSubmit={this.onFormSubmit}>
          <Field
            placeholder="Name"
            name="name"
            value={this.state.fields.name}
            onChange={this.onInputChange}
            validate={val => (val ? false : "Name Required")}
          />
          <Field
            placeholder="Email Address"
            name="email"
            value={this.state.fields.email}
            onChange={this.onInputChange}
            validate={val => (isEmail(val) ? false : "Invalid Email")}
          />
          <TextArea
            placeholder="Message"
            name="message"
            value={this.state.fields.message}
            onChange={this.onInputChange}
            validate={val => (val ? false : "Message Required")}
          />
          <div className="field is-grouped">
            <div className="control is-expanded">
              {
                {
                  SUBMITTING: (
                    <button
                      className="button is-brand is-fullwidth is-medium"
                      type="submit"
                      disabled
                    >
                      <span>Please Wait...</span>
                      <span className="icon">
                        <Icon name="spinner" spin />
                      </span>
                    </button>
                  ),
                  SUCCESS: (
                    <button
                      className="button is-success is-fullwidth is-medium"
                      type="submit"
                      disabled
                    >
                      Thank you, your message has been sent!
                    </button>
                  ),
                  ERROR: (
                    <button
                      className="button is-warning is-fullwidth is-medium"
                      value="Submission Failed - Retry?"
                      type="submit"
                      disabled={this.validate()}
                    >
                      Submission Failed - Retry?
                    </button>
                  ),
                  READY: (
                    <button
                      className="button is-brand is-fullwidth is-medium"
                      value="Submit"
                      type="submit"
                      disabled={this.validate()}
                    >
                      Submit
                    </button>
                  )
                }[this.state._submitStatus]
              }
            </div>
            {/* FIXME: Clear function empties fields, but validate errors remain */}
            {/* <div className="control">
                <button
                  className="button is-dark is-inverted is-medium"
                  onClick={this.clearFields}
                >
                  Clear
                </button>
              </div> */}
          </div>
        </form>
        {/* </div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Form.js